import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "page-title",
  "aria-level": "2",
  "data-test": "title"
}
const _hoisted_3 = {
  key: 1,
  class: "content-description",
  "data-test": "description"
}

import { computed } from "vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { useAssessmentStore, RecommendationType } from "@/store";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
import { ImageUrl, onSwiperCardFocus } from "@/helpers";
import { reportCourseView } from "@/helpers/reporting";
import ResourceCard from "@/components/Resource/ResourceCard/ResourceCard.vue";
import CourseOrCollectionCard from "@/components/CourseOrCollectionCard/CourseOrCollectionCard.vue";
import { parseImageUrl, getCourseProgress } from "@/helpers";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentRecommendations',
  setup(__props) {

SwiperCore.use(Navigation);

const assessmentStore = useAssessmentStore();

const assessment = computed(() => {
  return assessmentStore.getAssessmentDetail;
});

const assessmentRecommendations = computed(() => {
  return assessmentStore.getAssessmentRecommendations;
});

const parseFeatureImage = (image: ImageUrl): string | undefined => {
  return parseImageUrl(image, 300, 300) || undefined;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (assessment.value.contentTitle)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(assessment.value.contentTitle), 1))
        : _createCommentVNode("", true),
      (assessment.value.contentDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(SanityBlocks), {
              blocks: assessment.value.contentDescription
            }, null, 8, ["blocks"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Swiper), {
      onSwiper: _ctx.onSwiper,
      initialSlide: 0,
      slidesPerView: "auto",
      spaceBetween: 16,
      slidesOffsetAfter: 48,
      slidesOffsetBefore: 48,
      navigation: true,
      modules: _ctx.modules,
      watchSlidesProgress: true,
      id: "recommendations-swiper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessmentRecommendations.value, (recommendation, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: recommendation.baseSanityId,
            "data-test": "recommendation-carousel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "card-wrapper",
                to: {
          name:
            recommendation.type === _unref(RecommendationType).Resource
              ? 'ResourceDetail'
              : 'CourseDetail',
          params: { id: recommendation.content.base_id },
        },
                onFocus: ($event: any) => (_unref(onSwiperCardFocus)(index, _ctx.swiper)),
                onClick: ($event: any) => {
          if (recommendation.type !== _unref(RecommendationType).Resource) {
            _unref(reportCourseView)(recommendation.content.base_id);
          }
        }
              }, {
                default: _withCtx(() => [
                  (recommendation.type === _unref(RecommendationType).Resource)
                    ? (_openBlock(), _createBlock(ResourceCard, {
                        key: 0,
                        "data-test": "resource-card",
                        document: recommendation.content,
                        completed: recommendation.content.completed
                      }, null, 8, ["document", "completed"]))
                    : (_openBlock(), _createBlock(CourseOrCollectionCard, {
                        key: 1,
                        "data-test": "course-card",
                        class: "course-card",
                        type: "course",
                        title: recommendation.content.title,
                        description: recommendation.content.description,
                        thumbnail: parseFeatureImage(recommendation.content.feature_image),
                        placeholderImg: require('@/assets/course-thumbnail-placeholder.png'),
                        courseStatus: _unref(getCourseProgress)(recommendation.content)?.text,
                        courseStatusIcon: _unref(getCourseProgress)(recommendation.content)?.icon
                      }, null, 8, ["title", "description", "thumbnail", "placeholderImg", "courseStatus", "courseStatusIcon"]))
                ]),
                _: 2
              }, 1032, ["to", "onFocus", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["onSwiper", "modules"])
  ], 64))
}
}

})